import zipObj from 'ramda/src/zipObj'
import memoizeWith from 'ramda/src/memoizeWith'
import { moduleIdProp } from 'root/src/client/logic/route/lenses'
import formSchema from 'root/src/client/logic/form/selectors/formSchema'
import formData from 'root/src/client/logic/form/selectors/formData'

export default memoizeWith(
	(state, props) => JSON.stringify(formData(state, props)),
	(state, props) => zipObj(
		['formData', 'formSchema', 'moduleId', 'moduleKey'],
		[formData(state, props), formSchema(state, props), moduleIdProp(props), props.moduleKey],
	),
)
